import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {APPLICATION_JSON, CONTENT_TYPE} from '@/components/shared/consts';

export const rtkApi = createApi({
    reducerPath: 'rtk-api-slice',
    tagTypes: [],
    baseQuery: fetchBaseQuery({
        prepareHeaders: (headers) => {
            headers.set(CONTENT_TYPE, APPLICATION_JSON);
            return headers;
        },
    }),
    endpoints: () => ({}),
});
